import { render, staticRenderFns } from "./changePsw.vue?vue&type=template&id=427931b6&scoped=true&"
import script from "./changePsw.vue?vue&type=script&lang=js&"
export * from "./changePsw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427931b6",
  null
  
)

export default component.exports